import { initialState } from "./../initialState";
import * as LoginActions from "./loginActions";

export const loginReducer = (state = initialState.login, action) => {
    switch (action.type) {
        case LoginActions.CLEAR_AUTH:
        case LoginActions.REQUEST_LOGIN:
            return {
                authenticated: false,
                keycloak: null,
                bearerToken: "",
                userProfile: {},
                userInfo: {},
                technicianInfo: {},
            };

        case LoginActions.AUTHENTICATED:
            return {
                authenticated: true,
                keycloak: action.keycloak,
                bearerToken: action.keycloak.token,
                userProfile: action.userProfile,
                userInfo: action.userInfo,
                technicianInfo: action.technicianInfo,
            };

        case LoginActions.REFRESH_TOKEN:
            return {
                ...state,
                authenticated: true,
                keycloak: action.keycloak,
                bearerToken: action.keycloak.token,
            };
        default:
            return state;
    }
};
